import React, { useEffect, useState, useRef } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import { isEqual } from 'lodash'
import DatePicker from 'react-datepicker';
import { isMobileOnly } from 'react-device-detect';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Notification from 'rc-notification';
import SmallLoader from '../../../../shared/components/SmallLoader';
import { setCurrencyFormat } from '../../../../utils/helpers';
import ViewSalesReportModal from '../../SalesCategoryByDay/ViewSalesReportModal';
import {
    getBasketAnalysisData,
    handleLoader
}
    from '../../../../redux/actions/BasketAnalysisAction';
import BasketAnalysisTable from './BasketAnalysisTable';
import { filterShowWiseForBasketAnalysis as filterShowWise, vendorNameMapping, sortType } from '../../helper';

const BasketAnalysis = ({ dispatch, vendor }) => {
    const location = useLocation();

    const { basketAnalysisData, salesChannelFilterData, isLoading } = useSelector(
        ({ basketAnalysisReducer, marketPlaceReducer }) =>
        ({
            basketAnalysisData: basketAnalysisReducer?.[vendor]?.basketAnalysisData,
            isLoading: basketAnalysisReducer?.[vendor]?.isLoading,
            salesChannelFilterData: marketPlaceReducer.salesChannel,

        })
    );

    const salesChannelRef = useRef({})
    const previousMonthDate = new Date();
    previousMonthDate.setMonth(previousMonthDate.getMonth() - 1)

    const [basketAnalysisDataToShow, setDataToShow] = useState([]);
    const [showMarketPlaceMessage, setShowMarketPlaceMessage] = useState(false)
    const [isOpen, setIsOpen] = useState(false);
    const [filterData, setFilterData] = useState({});
    const [currentlyShow, setCurrentlyShow] = useState(filterShowWise?.[1])
    const [fromDate, setFromDate] = useState(previousMonthDate);
    const [toDate, setToDate] = useState(new Date());

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };

    const filterBasedOnFilter = (item) => {
        const filters = Object.keys(filterData);
        let flag = true
        // eslint-disable-next-line no-restricted-syntax
        for (const i of filters) {
            const filter = filterData[i];
            const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value?.toLowerCase()], []) ?? [];
            if (filtersArray?.length && !filtersArray.includes(item?.[i]?.toLowerCase())) {
                flag = false
            }
        }
        return flag
    }

    const countryCodeOptions = [];

    const callApi = () => {
        setShowMarketPlaceMessage(false)
        dispatch(handleLoader(true, vendor));
        dispatch(getBasketAnalysisData(
            {
                fromDate: moment(fromDate).format('YYYY-MM-DD'),
                toDate: moment(toDate).format('YYYY-MM-DD'),
                salesChannel: vendor === 'shopify' ? ['shopify.com'] :
                    filterData?.salesChannel?.map(item => item.value) || [],
                productCategorizationBasedOn: currentlyShow?.value,
                vendor
            }
        ));
    }

    const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
    const dvTb = document.getElementById('dvTable');
    dvTb.style.display = "none";  
    const element = container.current || document.body;
    
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
     // margin: "2cm",
     // forcePageBreak: ".page-break",
    //   landscape: true,
    //  multiPage: true,
      fileName: `${vendorNameMapping[vendor]} Basket Analysis Report ${new Date().getFullYear()}`,
    })
    dvTb.style.display = "block";  
  }

    const handleApplyDate = () => {
        const intFromDate = moment(fromDate).format('YYYYMMDD');
        const intToDate = moment(toDate).format('YYYYMMDD');
        if (intToDate > intFromDate) {
            callApi()
        }
        else {
            Notification.newInstance({}, (notification) => {
                notification.notice({
                    content: 'To Date must be greater than From Date.'
                });
            });
        }
    }

    const changeFilter = (value) => {
        setCurrentlyShow(value)
    };
    // eslint-disable-next-line array-callback-return
    basketAnalysisData?.modal?.filters?.sort((a, b) => a.sortingOrder - b.sortingOrder).map((data) => {
        data.filterData.forEach((element) => {
            countryCodeOptions.push({
                value: element.key,
                label: element.shortValue
            });
        });
    });

    // eslint-disable-next-line react/prop-types   

    useEffect(() => {
        callApi();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        setDataToShow(basketAnalysisData?.modal?.data?.[0]?.categoryWiseBasketAnalysis || []);

    }, [basketAnalysisData]);

    useEffect(() => {
        const OptChennel = 'salesChannel';
        if (salesChannelFilterData && !isEqual(salesChannelFilterData, salesChannelRef?.current?.salesChannel || [])) {
            setShowMarketPlaceMessage(true)
            salesChannelRef.current = { [OptChennel]: salesChannelFilterData }
            setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [salesChannelFilterData]);

    const dataToShowForDatesSelected = basketAnalysisDataToShow ?? [];

    // Data For Excel //

    const currentMonthCat = Object.keys(dataToShowForDatesSelected);
    const dataToPlot = [];
    const options = [];

    const reduceCallback = (acc, day) => {
        if (acc[day?.category]) {
            acc?.[day?.category]?.push(day)
        } else {
            acc[day?.category] = [day]
        }
        return acc
    }

    let TableHeader = [];

    for (let i = 0; i < currentMonthCat.length; i += 1) {
        const cat = currentMonthCat[i];
        const currentMonth = dataToShowForDatesSelected?.[cat] ?? [];
        const currentYearMonthDayWise = currentMonth?.reduce(reduceCallback, {})
        if (i === 0) {
            TableHeader = TableHeader.concat(Object.keys(currentYearMonthDayWise));
        }

        const categoryWiseAmountTotal = Object.keys(currentYearMonthDayWise).reduce((acc, category) => {
            let reoccurPer;
            if (cat === category) {
                reoccurPer = 0;
            }
            else {
                reoccurPer = currentYearMonthDayWise[category]?.[0]?.reOccurPerc;
            }
            acc[category] = {
                percentage: reoccurPer,
            };

            return acc
        }, {})
        options.push({
            value: cat, label: cat
        })
        dataToPlot.push({
            title: cat,
            categoryWiseAmountTotal,
        })

    }

    const dataToShowForExcel = [];
    const excelTableHeader = [];

    dataToPlot?.forEach((dataValue, index) => {
        const subData = {}
        subData.title = dataValue?.title;

        if (index === 0) {
            excelTableHeader.push({
                Header: currentlyShow?.value,
                accessor: 'title',
                disableGlobalFilter: false,
                width: 150,
                sortType
            })
        }
        TableHeader?.forEach((cat) => {
            subData[cat] = setCurrencyFormat(
                Number(dataValue?.categoryWiseAmountTotal?.[cat]?.percentage).toFixed(2), false);
            if (index === 0) {
                excelTableHeader.push({
                    Header: cat,
                    accessor: cat,
                    disableGlobalFilter: false,
                    width: 120,
                    sortType
                })
            }
        });
        dataToShowForExcel.push(subData)
    });

    const viewReportButton = () => (
        <div className="view-report">
            <button
                type="button"
                className="view-report btn btn-primary btn-sm"
                onClick={() => setIsOpen(true)}
                disabled={!dataToShowForExcel.length}
            >
                View Report
            </button>
        </div>
    )
    return (
        <Container className="dashboard">
            <Row className="category-sales">
                <Col sm="12">
                    <Card className="pb-3">
                        <CardBody className="min-w-50 p-3">
                            <div className="card__title mb-2">
                                <h5 className="bold-text card__title-center">
                                    {vendorNameMapping[vendor]} Basket Analysis</h5>
                            </div>
                            <Row className="align-items-center">
                                <Col sm="3" md="2">
                                    <div className="form__form-group mb-0">
                                        <span className="form__form-group-label">Show</span>
                                        <div className="form__form-group-field">
                                            <Select
                                                value={currentlyShow}
                                                options={filterShowWise}
                                                clearable={false}
                                                placeholder="Select "
                                                className="select_filter"
                                                onChange={value => changeFilter(value)}
                                                classNamePrefix="react-select"
                                            // isMulti
                                            />
                                        </div>

                                    </div>
                                </Col>
                                <Col sm="3" md="10">
                                    <Row className="align-items-center">
                                        <Col sm="3">
                                            <div className="form__form-group mb-0">
                                                <span className="form__form-group-label">From Date</span>
                                                <div className="form__form-group-field">
                                                    <div className="date-picker">
                                                        <DatePicker
                                                            className="form__form-group-datepicker"
                                                            selected={moment(fromDate).toDate()}
                                                            showPreviousMonths
                                                            onChange={handleFromDateChange}
                                                            dateFormat="MM/dd/yyyy"
                                                            dropDownMode="select"
                                                            popperPlacement="center"
                                                            withPortal={isMobileOnly}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col sm="3">
                                            <div className="form__form-group mb-0">
                                                <span className="form__form-group-label">To Date</span>
                                                <div className="form__form-group-field">
                                                    <div className="date-picker">
                                                        <DatePicker
                                                            className="form__form-group-datepicker"
                                                            selected={moment(toDate).toDate()}
                                                            onChange={handleToDateChange}
                                                            dateFormat="MM/dd/yyyy"
                                                            dropDownMode="select"
                                                            popperPlacement="center"
                                                            withPortal={isMobileOnly}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col sm="3" style={{ top: '10px' }}>
                                            <button className="btn btn-sm btn-primary apply-date-button"
                                                type="button" onClick={handleApplyDate}>
                                                Apply</button>
                                                <button className="btn btn-sm btn-primary
                                             apply-date-button"  type="button"
                                             title='Export to pdf' disabled={isLoading}
                                    onClick={exportToPDF}>Export PDF</button>
                                        </Col>
                                        <Col sm="3">
                                            <span style={{ color: 'red', alignItems: 'right' }}>
                                                {showMarketPlaceMessage ?
                                                    <small>*Hit Apply to fetch latest data </small> : ''}</span>
                                        </Col>
                                    </Row>
                                </Col>

                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <div id="divToPrint" ref={container}>
            <Card className="pb-3">
                <CardBody className="">
                    <div className="top-location"
                        style={{ minHeight: '400' }}>
                        <div >
                            {isLoading ? <div style={{ minHeight: '200px' }}
                                className="row align-items-center justify-content-center">
                                <SmallLoader loading={isLoading} />
                            </div>
                                : <BasketAnalysisTable
                                    dataToShowForDatesSelected={dataToShowForDatesSelected}
                                    viewReportButton={viewReportButton}
                                    categorisedBasedOn={currentlyShow?.value}
                                    title='Basket Analysis'
                                    currentlyShow={currentlyShow}
                                />}
                        </div>
                    </div>
                </CardBody>
            </Card>
            </div>
            <ViewSalesReportModal
                modalData={dataToShowForExcel}
                isOpen={isOpen}
                handleModal={setIsOpen}
                tableHeaderData={excelTableHeader}
                title='Basket Analysis Report'
                fileName='Basket Analysis Report'
            />
        </Container>
    );
};

BasketAnalysis.propTypes = {
    dispatch: PropTypes.func.isRequired,
    vendor: PropTypes.number.isRequired
}

export default connect(state => ({
    rtl: state.rtl,
}))(BasketAnalysis);